import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Form } from "react-final-form";
import * as yup from "yup";
import { Grid } from "@mui/material";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import FormHelperText from "@mui/material/FormHelperText";
import { UiInputGroupWr } from "../../../../../../_uiComponents/common/form/UiInputComponents";

import UiInput from "../../../../../../_uiComponents/UiInput";

import { UiRadioBtn } from "../../../../../../_uiComponents/common/form/UiRadioBtn";

import UiSwitch from "../../../../../../_uiComponents/common/form/UiSwitch";
import MultiSelect from "../../../../../../_uiComponents/common/form/MultiSelect";
import {
     UiButton,
     UiBackButton,
} from "../../../../../../_uiComponents/common/form/UiButton";
import UiSelect from "../../../../../../_uiComponents/common/form/UiSelect";
import UiDateRangePicker from "../../../../../../_uiComponents/common/form/UiDateRangePicker";
import HierarchyDataGrid from "../../../HierarchyDataGrid";
import Validator from "../../../../../../../_helpers/validate.schema";
import {
     campaignTypesRequest,
     getCampaignParticipantsRequest,
     getCampaignSalesRequest,
     getCampaignTemplateTypeRequest,
     getCampaignProductRequest,
     participantListRequest,
     creationStepOneRequest,
     getParticipantDataTemplateRequest,
     getSalseDataTemplateRequest,
     updateAboutCampaignStepOneRequest,
} from "../../../../../../../_redux/_actions";
import AccordionComponent from "../../../../../../_uiComponents/common/AccordionComponent";
import CampaignAdminGrid from "../CampaignAdminGrid";
import {
     FORM_TYPE_ADD,
     FORM_TYPE_EDIT,
} from "../../../../../../../_helpers/constants";

const validateSchema = () =>
     yup.object().shape({
          campaignName: yup.string().required("Name is required."),
          campaingType: yup.string().required("Type is required."),

          // participantTemplateId: yup
          //      .string()
          //      .required("Participant data template is required."),
          // saleTemplateId: yup
          //      .string()
          //      .required("Salse data template is required."),

          // campaignTemplateId: yup
          //      .string()
          //      .required("Template Type is required."),
          dateRange: yup
               .array()
               .min(2, "Start date and End data are required.")
               .required("Duration is required."),
     });

const onValidate = async (values) => {
     return await Validator(values, validateSchema);
};

export default function AboutCampaignForm(props) {
     const [initialValues, setInitialValues] = useState({});
     const [expanded, setExpanded] = React.useState('AboutCampaign');
     const actionDispatch = useDispatch();
     let navigate = useNavigate();

     const { campaignDetails } = useSelector((state) => {
          return {
               campaignDetails: state.incentive.aboutCampaignStepOne,
          };
     });

     useEffect(() => {
          setInitialValues(campaignDetails);
          if (campaignDetails.campaignTypeId) {
               getCampaignTypeTemplate(campaignDetails.campaignTypeId);
          }
     }, [campaignDetails]);

     const {
          campaignTypes,
          campaignParticipants,
          campaignSales,
          campaignTemplateType,
          campaignProducts,
          participantDataTemplates,
          salseDataTemplates,
     } = useSelector((state) => {
          return {
               campaignTypes: state.incentive.camapaignTypes,
               campaignParticipants: state.incentive.campaignParticipants,
               campaignSales: state.incentive.campaignSales,
               campaignTemplateType: state.incentive.campaignTemplateType,
               campaignProducts: state.incentive.campaignProducts,
               participantDataTemplates:
                    state.incentive.participantDataTemplates,
               salseDataTemplates: state.incentive.salseDataTemplates,
          };
     });

     useEffect(() => {
          actionDispatch(campaignTypesRequest());
          actionDispatch(getParticipantDataTemplateRequest());
          actionDispatch(getSalseDataTemplateRequest());

          // actionDispatch(getCampaignParticipantsRequest());
          // actionDispatch(getCampaignSalesRequest());

          // getParticipantList("Hierarchy");
     }, [props.activeStep]);

     const getProductsByTemplateId = (id) => {
          actionDispatch(getCampaignProductRequest({ id }));
     };

     const getParticipantList = (type) => {
          actionDispatch(participantListRequest({ type }));
     };

     const getCampaignTypeTemplate = (id) => {
         // actionDispatch(getCampaignTemplateTypeRequest({ id }));
     };

     const submit = async (values) => {
          if (props.type == FORM_TYPE_EDIT) {
               const payload = {
                    id: campaignDetails.id,
                    name: values.campaignName,
                    description: values.description,

                    active: values.active,
                    startDate: values.dateRange[0],
                    endDate: values.dateRange[1],

                    handleStep: props.handleStep,
               };

               delete payload.dateRange;

               actionDispatch(updateAboutCampaignStepOneRequest(payload));
          } else {
               let active = false;

               if (values.active) {
                    active = true;
               } else {
                    active = false;
               }

               const payload = {
                    name: values.campaignName,
                    description: values.description,
                    incentiveCampaignTypeId: values.campaingType,
                    incentiveCampaignTemplateId: values.campaignTemplateId,
                    active: active,
                    startDate: values.dateRange[0],
                    endDate: values.dateRange[1],

                    participantTemplateId: values.participantTemplateId,
                    saleTemplateId: values.saleTemplateId,

                    handleStep: props.handleStep,
                    navigate
               };

               delete payload.dateRange;

               actionDispatch(creationStepOneRequest(payload));
          }
     };

     
     const handleChange = (panel) => (event, isExpanded) => {
          setExpanded(isExpanded ? panel : false);
     };

     return (
          <AccordionComponent
               expanded={expanded === 'AboutCampaign'}
               handleChange={handleChange('AboutCampaign')}
               title="About Campaign">
               <Form
                    onSubmit={submit}
                    validate={onValidate}
                    mutators={{
                         setFormAttribute: (
                              [fieldName, fieldVal],
                              state,
                              { changeValue },
                         ) => {
                              changeValue(state, fieldName, () => fieldVal);
                         },
                    }}
                    // 2024-07-08
                    initialValues={
                         props.type === FORM_TYPE_EDIT && {
                              campaignName: initialValues?.campaignName,
                              description: initialValues?.description,
                             // campaingType: initialValues?.campaignTypeId,
                             // campaignTemplateId:initialValues?.campaignTemplateId,
                             // participantTemplateId:initialValues?.participantDataTemplateId,
                            //  saleTemplateId: initialValues?.saleDataTemplateId,
                              active: initialValues?.active,
                              dateRange: [
                                   moment
                                        .utc(initialValues?.startDate)
                                        .local()
                                        .format("YYYY-MM-DD") + " 00:00:00",
                                   moment
                                        .utc(initialValues?.endDate)
                                        .local()
                                        .format("YYYY-MM-DD") + " 00:00:00",
                              ],
                         }
                    }
                    render={({ form, handleSubmit, values, ...formValues }) => {
                         return (
                              <form onSubmit={validateSchema}>
                                   <>
                                        <Grid container spacing={2}>
                                             <Grid
                                                  item
                                                  xs={12}
                                                  lg={12}
                                                  sx={{ pt: 2, pb: 2 }}
                                             >
                                                  <Grid
                                                       container
                                                       spacing={2}
                                                       sx={{ pb: 1 }}
                                                  >
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={12}
                                                            sx={{
                                                                 textAlign:
                                                                      "left",
                                                                 display: "flex",
                                                                 alignItems:
                                                                      "center",
                                                            }}
                                                       >
                                                            <div className="sba-radio-label sba-campaign-type">
                                                                 Type
                                                            </div>
                                                            <FormControl>
                                                                 <div className="sba-radio">
                                                                      <RadioGroup
                                                                           row
                                                                           aria-labelledby="demo-row-radio-buttons-group-label"
                                                                           name="row-radio-buttons-group"
                                                                      >
                                                                           {campaignTypes.map(
                                                                                (
                                                                                     campaignType,
                                                                                ) => {
                                                                                     return (
                                                                                          <UiRadioBtn
                                                                                               disabled={
                                                                                                    props.type ==
                                                                                                         FORM_TYPE_EDIT
                                                                                                         ? true
                                                                                                         : false
                                                                                               }
                                                                                               checked={
                                                                                                    campaignType.id ==
                                                                                                    values.campaingType
                                                                                               }
                                                                                               onClick={(
                                                                                                    e,
                                                                                               ) => {
                                                                                                    form.mutators.setFormAttribute(
                                                                                                         "campaingType",
                                                                                                         campaignType.id,
                                                                                                    );

                                                                                                    form.mutators.setFormAttribute(
                                                                                                         "campaignTemplateId",
                                                                                                         "",
                                                                                                    );

                                                                                                    getCampaignTypeTemplate(
                                                                                                         campaignType.id,
                                                                                                    );
                                                                                               }}
                                                                                               value={
                                                                                                    campaignType.name
                                                                                               }
                                                                                               control={
                                                                                                    <Radio />
                                                                                               }
                                                                                               label={
                                                                                                    campaignType.name
                                                                                               }
                                                                                          />
                                                                                     );
                                                                                },
                                                                           )}
                                                                      </RadioGroup>
                                                                      {form.getState()
                                                                           .submitFailed &&
                                                                           formValues
                                                                                .errors
                                                                                .campaingType && (
                                                                                <FormHelperText className="sba-form-error">
                                                                                     {
                                                                                          formValues
                                                                                               .errors
                                                                                               .campaingType
                                                                                     }
                                                                                </FormHelperText>
                                                                           )}
                                                                 </div>
                                                            </FormControl>
                                                       </Grid>
                                                  </Grid>
                                                  {/* {values.campaingType && (
                                                       <Grid
                                                            container
                                                            spacing={2}
                                                            sx={{ mb: 1 }}
                                                       >
                                                            <Grid
                                                                 item
                                                                 xs={12}
                                                                 lg={6}
                                                            >
                                                                 <UiSelect
                                                                      disabled={
                                                                           props.type ==
                                                                                FORM_TYPE_EDIT
                                                                                ? true
                                                                                : false
                                                                      }
                                                                      label="Campaign Template"
                                                                      name="campaignTemplateId"
                                                                      placeholder="Select template"
                                                                      // onChange={
                                                                      //      getProductsByTemplateId
                                                                      // }
                                                                      options={campaignTemplateType.map(
                                                                           (
                                                                                sale,
                                                                           ) => {
                                                                                return {
                                                                                     value: sale.id,
                                                                                     label: sale.name,
                                                                                };
                                                                           },
                                                                      )}
                                                                 />
                                                            </Grid>
                                                       </Grid>
                                                  )} */}
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <UiInput
                                                                 maxLength="150"
                                                                 name="campaignName"
                                                                 type="text"
                                                                 label="Name"
                                                                 id="campaing-creation-name-field"
                                                            />
                                                       </Grid>
                                                  </Grid>
                                                  <Grid
                                                       container
                                                       spacing={2}
                                                       sx={{ mb: 1 }}
                                                  >
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            {/* <UiSelect
                                                                 disabled={
                                                                      props.type ==
                                                                           FORM_TYPE_EDIT
                                                                           ? true
                                                                           : false
                                                                 }
                                                                 label="Participant Data Template"
                                                                 name="participantTemplateId"
                                                                 placeholder="Select template"
                                                                 // onChange={
                                                                 //      getProductsByTemplateId
                                                                 // }
                                                                 options={participantDataTemplates.map(
                                                                      (
                                                                           sale,
                                                                      ) => {
                                                                           return {
                                                                                value: sale.id,
                                                                                label: sale.name,
                                                                           };
                                                                      },
                                                                 )}
                                                            /> */}
                                                       </Grid>
                                                  </Grid>
                                                  {/* <Grid
                                                       container
                                                       spacing={2}
                                                       sx={{ mb: 1 }}
                                                  >
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <UiSelect
                                                                 disabled={
                                                                      props.type ==
                                                                           FORM_TYPE_EDIT
                                                                           ? true
                                                                           : false
                                                                 }
                                                                 label="Sales Data Template"
                                                                 name="saleTemplateId"
                                                                 placeholder="Select template"
                                                                 // onChange={
                                                                 //      getProductsByTemplateId
                                                                 // }
                                                                 options={salseDataTemplates.map(
                                                                      (
                                                                           sale,
                                                                      ) => {
                                                                           return {
                                                                                value: sale.id,
                                                                                label: sale.name,
                                                                           };
                                                                      },
                                                                 )}
                                                            />
                                                       </Grid>
                                                  </Grid> */}

                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <div className="sba-date-range-picker">
                                                                 <UiDateRangePicker
                                                                      name="dateRange"
                                                                      dateRange={
                                                                           props.type ==
                                                                                FORM_TYPE_EDIT
                                                                                ? values.dateRange
                                                                                : false
                                                                      }
                                                                 />
                                                            </div>
                                                       </Grid>
                                                  </Grid>

                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <UiInput
                                                                 label="Description"
                                                                 multiline={
                                                                      true
                                                                 }
                                                                 minRows={3}
                                                                 maxRows={5}
                                                                 name="description"
                                                            />
                                                       </Grid>
                                                  </Grid>
                                                  <Grid container spacing={2}>
                                                       <Grid
                                                            item
                                                            xs={12}
                                                            lg={6}
                                                       >
                                                            <FormControlLabel
                                                                 control={
                                                                      <UiSwitch
                                                                           name="active"
                                                                           checked={
                                                                                props.type ==
                                                                                     FORM_TYPE_EDIT
                                                                                     ? values.active
                                                                                     : false
                                                                           }
                                                                      />
                                                                 }
                                                                 label="Active"
                                                                 labelPlacement="top"
                                                                 sx={{
                                                                      mt: 1,
                                                                 }}
                                                                 className="sba-campaign-switch-label"
                                                            />
                                                       </Grid>
                                                  </Grid>
                                             </Grid>
                                        </Grid>

                                        <div className="sba-campaign-content-button">
                                             <UiButton
                                                  name="Clear"
                                                  variant="outlined"
                                                  size="large"
                                             />
                                             <UiButton
                                                  name={
                                                       props.type ==
                                                            FORM_TYPE_EDIT
                                                            ? "Update"
                                                            : "Save"
                                                  }
                                                  variant="contained"
                                                  size="large"
                                                  onClick={handleSubmit}
                                             />
                                        </div>
                                   </>
                              </form>
                         );
                    }}
               />
          </AccordionComponent>
     );
}
